<template>
  <div class="step-dcf">
    <div class="steps-container">
      <div class="width-67">
        <ul class="steps has-content-centered">
          <li v-for="(step, index) in steps"
              :key="index"
              class="steps-segment" :class="[{ 'is-active' : lastActiveStep === index },
          step.customClassSegment]">
        <span class="steps-marker"
              :class="[{ 'is-hollow' : actualStep === index }, step.customClassMarker]">
          <b-icon :icon="step.icon" size="is-small" custom-class="has-text-weight-bold"
                  v-if="step.icon">
          </b-icon>
        </span>
            <div class="steps-content">
              <div class="level is-justify-content-center mb-0">
                <div class="level-left">
                  <div class="level-item">
                    <router-link-blank v-if="step.link"
                      :classMessage="getClassLibelle(step, index)"
                      :to="{ name: step.link, params: step.paramLink }"
                      :message="$t(step.libelle, step.paramsLibelle)">
                    </router-link-blank>
                    <p v-else
                        :class="getClassLibelle(step, index)"
                        class="has-text-weight-bold">
                      {{ $t(step.libelle) }}
                    </p>
                  </div>
                  <div class="level-item">
                    <b-tooltip :active="step.iconSignatureColor !== null" multilined>
                      <template v-slot:content v-if="step.infoSurSiganture">
                        <div class="has-text-left">
                          <b>{{ step.infoSurSiganture.libelle }}</b><br/>
                          {{ $t('detail.signatureElectronique.demandeur') }}
                            {{ step.infoSurSiganture.initiateur}}<br/>
                          {{ $t('detail.signatureElectronique.dateEnvoie') }}
                            {{ step.infoSurSiganture.dateEnvoi}}
                          <span v-if = 'step.infoSurSiganture.dateSignature'>
                            <br/>
                          {{ $t('detail.signatureElectronique.dateSignature') }}
                            {{ step.infoSurSiganture.dateSignature}}
                          </span>
                        </div>
                      </template>
                      <b-icon
                        icon="signature-freehand"
                        :type="step.iconSignatureColor"
                        v-if="step.iconSignatureColor"/>
                    </b-tooltip>
                  </div>
                </div>
              </div>
              <p :class="[actualStep === index ? 'has-text-link' : 'has-text-default']"
                 v-if="step.sousLibelle">
                {{ $t('detailDevis.etat') }} {{ $t(step.sousLibelle) }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  name: 'DevisCommandeFactureDetailStepper',
  props: {
    steps: {
      type: Array,
      required: true,
    },
    lastActiveStep: {
      type: Number,
      required: true,
    },
    actualStep: {
      type: Number,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
  methods: {
    getClassLibelle(step, index) {
      let classLibelle = '';
      if (step.link) classLibelle += 'is-underline';
      if (this.actualStep === index) classLibelle += ' has-text-link';
      else if (!step.isActive) classLibelle += ' has-text-secondary-icon';
      else classLibelle += ' has-text-default';
      return classLibelle;
    },
  },
};
</script>
